<template>
  <ValidationObserver
    ref="obs"
    v-slot="{ }"
  >
    <v-container
      class="pb-0"
    >
      <v-row
        align="center"
        class="py-0"
      >
        <v-col
          class="py-0"
          cols="12"
          offset-sm="4"
          offset-md="10"
          sm="4"
          md="2"
        >
          <v-row
            class="py-0 px-5"
            align="center"
            justify="center"
          >
            <v-col
              class="pb-0 d-flex"
              cols="2"
              sm="5"
            >
              <v-img
                :class="locale === 'en' ? 'idioma-activo' : ''"
                src="../../../../../../public/img/bandera-estados-unidos.png"
                :alt="$t('bandera_reino_unido')"
                @click="cambiarIdioma('en')"
              />
              <span class="ml-1 my-auto v-label theme--light">{{ $t('texto_ingles') }}</span>
            </v-col>
            <v-col
              class="pb-0 d-flex"
              cols="2"
              offset="2"
              offset-sm="2"
              sm="5"
            >
              <v-img
                :class="locale === 'es' ? 'idioma-activo' : ''"
                src="../../../../../../public/img/bandera-espanha.png"
                :alt="$t('bandera_espanha')"
                @click="cambiarIdioma('es')"
              />
              <span class="ml-1 my-auto v-label theme--light">{{ $t('texto_espanhol') }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col class="text-center">
          <h1 class="d-inline customer--title text-center">
            {{ $t('title') }}
          </h1>
        </v-col>
      </v-row>
      <v-form
        @submit.prevent="() => {}"
      >
        <v-row>
          <v-col
            class="mb-0 py-0 mx-auto"
            cols="11"
            sm="10"
            md="5"
          >
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.obra_id')"
              :rules="validacionesFormulario.obraId"
              vid="obraId"
            >
              <v-autocomplete
                id="obraId"
                v-model="objObra"
                :error-messages="errors"
                :label="$t('form.label.obra_id')"
                :items="obraIds"
                :disabled="disabled.obra"
                class="required"
                item-text="descripcion"
                item-value="id"
                background-color="white"
                name="obraId"
                filled
                return-object
                dense
                outlined
                v-on="$listeners"
                @change="conseguirCampanhas"
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.camapanha_donacion')"
              :rules="validacionesFormulario.campanaDonacionId"
              vid="campanaDonacionId"
            >
              <v-autocomplete
                id="campanaDonacionId"
                v-model="modelo.campanaDonacionId"
                :error-messages="errors"
                :label="$t('form.label.camapanha_donacion')"
                :items="campanaDonacionIds"
                :disabled="disabled.campana"
                class="required"
                item-text="descripcion"
                item-value="id"
                background-color="white"
                name="camapanha_donacion"
                filled
                dense
                outlined
                v-on="$listeners"
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.tipo_documento')"
              :rules="validacionesFormulario.tipoDocumentoId"
              vid="tipoDocumentoId"
            >
              <v-autocomplete
                id="tipoDocumentoId"
                v-model="objtipoDocumentoIds"
                :error-messages="errors"
                :label="$t('form.label.tipo_documento')"
                :items="tipoDocumentoIds"
                :disabled="disabled.tipoDocumento"
                class="required"
                item-text="descripcion"
                item-value="id"
                background-color="white"
                name="tipoDocumentoId"
                filled
                return-object
                dense
                outlined
                v-on="$listeners"
                @change="limpiarCampos"
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.numero_documento')"
              :rules="validacionesFormulario.numeroDocumento"
              vid="numeroDocumento"
            >
              <v-text-field
                id="numeroDocumento"
                v-model.trim="modelo.numeroDocumento"
                :error-messages="errors"
                :label="$t('form.label.numero_documento')"
                :disabled="disabled.numeroDocumento"
                type="text"
                background-color="white"
                class="required"
                name="numeroDocumento"
                dense
                outlined
                required
              />
            </ValidationProvider>
            <ValidationProvider
              v-if="objtipoDocumentoIds ? objtipoDocumentoIds.codigo !== 'NIT' : true"
              v-slot="{ errors }"
              :name="$t('form.label.nombre')"
              :rules="validacionesFormulario.nombre"
              vid="nombre"
            >
              <v-text-field
                id="nombre"
                v-model.trim="modelo.nombre"
                :error-messages="errors"
                :label="$t('form.label.nombre')"
                :disabled="disabled.nombre"
                type="text"
                background-color="white"
                class="required"
                name="nombre"
                dense
                outlined
                required
              />
            </ValidationProvider>
            <ValidationProvider
              v-if="objtipoDocumentoIds ? objtipoDocumentoIds.codigo !== 'NIT' : true"
              v-slot="{ errors }"
              :name="$t('form.label.apellidos')"
              :rules="validacionesFormulario.apellidos"
              vid="apellidos"
            >
              <v-text-field
                id="apellidos"
                v-model.trim="modelo.apellido"
                :error-messages="errors"
                :label="$t('form.label.apellidos')"
                :disabled="disabled.apellido"
                type="text"
                background-color="white"
                class="required"
                name="apellidos"
                dense
                outlined
                required
              />
            </ValidationProvider>
            <ValidationProvider
              v-if="objtipoDocumentoIds ? objtipoDocumentoIds.codigo === 'NIT' : false"
              v-slot="{ errors }"
              :name="$t('form.label.razon_social')"
              :rules="validacionesFormulario.razonSocial"
              vid="razonSocial"
            >
              <v-text-field
                id="razonSocial"
                v-model.trim="modelo.razonSocial"
                :error-messages="errors"
                :label="$t('form.label.razon_social')"
                :disabled="disabled.razonSocial"
                type="text"
                background-color="white"
                class="required"
                name="razonSocial"
                dense
                outlined
                required
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.correo_electronico')"
              :rules="validacionesFormulario.correoElectronico"
              vid="correoElectronico"
            >
              <v-text-field
                id="correoElectronico"
                v-model.trim="modelo.correoElectronico"
                :error-messages="errors"
                :label="$t('form.label.correo_electronico')"
                :disabled="disabled.correoElectronico"
                type="text"
                background-color="white"
                class="required"
                name="correoElectronico"
                dense
                outlined
                required
                @paste.prevent
                @dragover.prevent
                @drop.prevent
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.confirmacion_correo_electronico')"
              :rules="validacionesFormulario.confirmacionCorreoElectronico"
              vid="confirmacionCorreoElectronico"
            >
              <v-text-field
                id="confirmacionCorreoElectronico"
                v-model.trim="modelo.confirmacionCorreoElectronico"
                :error-messages="errors"
                :label="$t('form.label.confirmacion_correo_electronico')"
                :disabled="disabled.confirmacionCorreoElectronico"
                type="text"
                background-color="white"
                class="required"
                name="confirmacionCorreoElectronico"
                dense
                outlined
                required
                @paste.prevent
                @dragover.prevent
                @drop.prevent
              />
            </ValidationProvider>
          </v-col>
          <v-col
            class="mb-0 py-0 mx-auto"
            cols="11"
            sm="10"
            md="5"
            offset-md="2"
          >
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.pais_id')"
              :rules="validacionesFormulario.paisId"
              vid="paisId"
            >
              <v-autocomplete
                id="paisId"
                v-model="objpais"
                :error-messages="errors"
                :label="$t('form.label.pais_id')"
                :items="paisIds"
                :disabled="disabled.pais"
                class="required"
                item-text="descripcion"
                item-value="id"
                background-color="white"
                name="paisId"
                filled
                dense
                outlined
                return-object
                v-on="$listeners"
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.ciudad')"
              :rules="validacionesFormulario.ciudad"
              vid="ciudad"
            >
              <v-text-field
                id="ciudad"
                v-model.trim="modelo.ciudad"
                :error-messages="errors"
                :label="$t('form.label.ciudad')"
                :disabled="disabled.ciudad"
                type="text"
                background-color="white"
                class="required"
                name="ciudad"
                dense
                outlined
                required
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.direccion')"
              :rules="validacionesFormulario.direccion"
              vid="direccion"
            >
              <v-text-field
                id="direccion"
                v-model.trim="modelo.direccion"
                :error-messages="errors"
                :label="$t('form.label.direccion')"
                :disabled="disabled.direccion"
                type="text"
                background-color="white"
                name="direccion"
                dense
                outlined
                required
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.telefono')"
              :rules="validacionesFormulario.telefono"
              vid="telefono"
            >
              <v-text-field
                id="telefono"
                v-model.trim="modelo.telefono"
                :error-messages="errors"
                :label="$t('form.label.telefono')"
                :disabled="disabled.telefono"
                type="text"
                background-color="white"
                class="required"
                name="telefono"
                :prefix="objpais ? objpais.codigoTelefonico : ''"
                dense
                outlined
                required
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.tipo_moneda')"
              :rules="validacionesFormulario.tipoMoneda"
              vid="tipoMoneda"
            >
              <v-autocomplete
                id="tipoMoneda"
                v-model="modelo.tipoMoneda"
                :error-messages="errors"
                :label="$t('form.label.tipo_moneda')"
                :items="generalParameters.tiposMonedas"
                :disabled="disabled.tipoMoneda"
                class="required"
                item-text="descripcion"
                item-value="codigo"
                background-color="white"
                name="tipoMoneda"
                filled
                dense
                outlined
                v-on="$listeners"
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.valor')"
              :rules="reglaValor"
              vid="valor"
            >
              <v-currency-field
                id="valor"
                v-model="modelo.valor"
                :error-messages="errors"
                :label="$t('form.label.valor')"
                :disabled="disabled.valor"
                :decimal-length="cantidadDecimalesValor"
                auto-decimal-mode
                filled
                background-color="white"
                class="required"
                name="valor"
                maxlength="21"
                dense
                outlined
                required
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :rules="validacionesFormulario.aceptaTerminosCondiciones"
              :name="$t('form.label.acepta_terminos_condiciones_label')"
              vid="aceptaTerminosCondiciones"
            >
              <v-checkbox
                id="aceptaTerminosCondiciones"
                v-model="modelo.aceptaTerminosCondiciones"
                :label="$t('form.label.acepta_terminos_condiciones')"
                :error-messages="errors"
                class="mt-0 required justify-center justify-sm-start"
                name="aceptaTerminosCondiciones"
                value="true"
              >
                <i18n
                  slot="label"
                  path="form.label.acepta_terminos_condiciones"
                  tag="span"
                >
                  <template v-slot:link_acepta_terminos_condiciones>
                    <a
                      :href="objObra ? objObra.urlTerminosCondiciones : '#'"
                      target="_blank"
                      @click="abrirLinkTerminosCondiciones()"
                    >
                      {{ $t('form.label.link_acepta_terminos_condiciones') }}
                    </a>
                  </template>
                </i18n>
              </v-checkbox>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :rules="validacionesFormulario.aceptaTratamientoDatos"
              :name="$t('form.label.acepta_tratamiento_datos_label')"
              vid="aceptaTratamientoDatos"
            >
              <v-checkbox
                id="aceptaTratamientoDatos"
                v-model="modelo.aceptaTratamientoDatos"
                :error-messages="errors"
                class="mt-0 justify-center justify-sm-start"
                name="aceptaTratamientoDatos"
                value="true"
              >
                <i18n
                  slot="label"
                  path="form.label.acepta_tratamiento_datos"
                  tag="span"
                >
                  <template v-slot:link_acepta_tratamiento_datos>
                    <a
                      :href="objObra ? objObra.urlPoliticaTratamientoDatos : '#'"
                      target="_blank"
                      @click="abrirLink()"
                    >
                      {{ $t('form.label.link_acepta_tratamiento_datos') }}
                    </a>
                  </template>
                </i18n>
              </v-checkbox>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <botones-epayco
            :value="epaycoModel"
            :datos-obra="objObra"
            :validar-formulario="validarFormulario"
          />
        </v-row>
        <input
          id="honeypot"
          name="honeypot"
          type="hidden"
          :value="modelo.honeypot"
        >
      </v-form>
      <v-row>
        <v-col
          cols="10"
          sm="8"
          class="mx-auto"
        >
          <p class="v-label theme--light text-center text-justify text-sm-center">
            <i18n
              slot="label"
              path="texto_donaciones"
              tag="span"
            >
              <template v-slot:correo>
                <a
                  :href="`mailto:${$t('correo')}`"
                >
                  {{ $t('correo') }}
                </a>
              </template>
            </i18n>
          </p>
        </v-col>
      </v-row>
      <modal-terminos-condiciones
        :mostrar-terminos="mostrarModal"
        @aceptarTerminosCondiciones="modificarTerminosCondiciones"
      />
    </v-container>
  </ValidationObserver>
</template>

<script>
import handleErrorMixin from '../../../../../mixins/handleErrorMixin'
import recaptchaV3Mixin from '../../../../../mixins/recaptchaV3Mixin'
import validateQueryParamsMixin from '@/mixins/validateQueryParamsMixin'
import generalParametersMixin from '@/mixins/generalParametersMixin'
import validacionesFormulario from './data/donacionesValidations'
import ModalTerminosCondiciones from './components/modalTerminosCondiciones/ModalTerminosCondiciones'
import BotonesEpayco from '@/components/uiComponents/pasarelasPagos/botonesEpayco/BotonesEpayco'
import {
  TRAER_OBRAS,
  TRAER_TIPOS_DOCUMENTOS,
  TRAER_PAISES,
  GUARDAR_DONACION,
  DEFAULT_FIELDS_DISABLED,
  CONFIGURATION_VALIDATE_QUERY_PARAMETERS,
  URL_RESPONSE_EPAYCO,
  WEBHOOK_CONFIRMACION_EPAYCO,
  FIELDS_DEFAULT_EPAYCO_CHECKOUT,
  SERVICIO_PASARELA_DONACION_CODIGO
} from './data/donacionesConstants'
import { NOT_FOUND } from '../../../../../shared/constants/httpStatus'
import { CHANGE_LANGUAGE } from '../../../../../store/mutations-types'
import { mapState } from 'vuex'

/**
 * Componente para crear formulario de donaciones
 *
 * @author Valentin Agudelo Aquite
 * @version 1.0.0
 * @since 20/02/2020 08:36 a. m.
 */
export default {
  name: 'Donaciones',
  components: {
    ModalTerminosCondiciones,
    BotonesEpayco
  },
  mixins: [handleErrorMixin, recaptchaV3Mixin, validateQueryParamsMixin, generalParametersMixin],
  data () {
    return {
      disabled: DEFAULT_FIELDS_DISABLED,
      validaQueryParam: CONFIGURATION_VALIDATE_QUERY_PARAMETERS,
      modelo: {
        obraId: null,
        campanaDonacionId: null,
        tipoDocumentoId: null,
        numeroDocumento: null,
        nombre: null,
        apellido: null,
        razonSocial: null,
        correoElectronico: null,
        confirmacionCorreoElectronico: null,
        telefono: null,
        valor: 0,
        paisId: null,
        ciudad: null,
        direccion: null,
        aceptaTerminosCondiciones: null,
        aceptaTratamientoDatos: null,
        tipoMoneda: null,
        honeypot: ''
      },
      generalParametersUrlLogo: null,
      objObra: null,
      objtipoDocumentoIds: null,
      objpais: null,
      obraIds: [],
      campanaDonacionIds: [],
      tipoDocumentoIds: [],
      paisIds: [],
      validacionesFormulario: validacionesFormulario,
      mostrarModal: false,
      handler: null
    }
  },
  computed: {
    ...mapState(['changeLanguage', 'configColor', 'generalParameters']),
    campaignSeleccionada () {
      return !this.modelo.campanaDonacionId ? {} : this.campanaDonacionIds.find(campaign => {
        if (campaign.id === this.modelo.campanaDonacionId) {
          return campaign
        }
      })
    },
    reglaValor () {
      if (this.modelo.tipoMoneda === null || this.modelo.tipoMoneda.toUpperCase() === 'COP') {
        return this.validacionesFormulario.valor
      }
      return {
        ...this.validacionesFormulario.valor,
        min_value: 0.01
      }
    },
    cantidadDecimalesValor () {
      if (this.modelo.tipoMoneda === null || this.modelo.tipoMoneda.toUpperCase() === 'COP') {
        return 0
      }
      return 2
    },
    epaycoModel () {
      return {
        // Parametros compra (obligatorio)
        name: 'DONACIÓN',
        description: this.campaignSeleccionada.descripcion,
        invoice: undefined,
        currency: this.modelo.tipoMoneda,
        amount: this.modelo.valor,
        tax_base: this.modelo.valor,
        tax: FIELDS_DEFAULT_EPAYCO_CHECKOUT.SIN_IVA,
        country: this.objpais ? this.objpais.codigoAlfaDos.toLowerCase() : null,
        lang: this.changeLanguage,
        // Onpage='false' - Standard='true'
        external: FIELDS_DEFAULT_EPAYCO_CHECKOUT.EXTERNAL_CHECKOUT,
        // Atributos opcionales
        extra1: SERVICIO_PASARELA_DONACION_CODIGO,
        extra2: JSON.stringify(this.modelo),
        extra3: undefined,
        confirmation: WEBHOOK_CONFIRMACION_EPAYCO,
        response: URL_RESPONSE_EPAYCO,
        // Atributos cliente
        name_billing: `${this.modelo.nombre} ${this.modelo.apellido}`,
        address_billing: this.modelo.direccion,
        type_doc_billing: this.objtipoDocumentoIds ? this.objtipoDocumentoIds.codigo.toLowerCase() : null,
        mobilephone_billing: this.modelo.telefono,
        number_doc_billing: this.modelo.numeroDocumento,
        email_billing: this.modelo.correoElectronico
        // atributo deshabilitación metodo de pago
        // methodsDisable: ['TDC', 'PSE', 'SP', 'CASH', 'DP']
      }
    }
  },
  watch: {
    objObra (obra) {
      this.modelo.obraId = obra ? obra.id : null
    },
    objtipoDocumentoIds (tipoDocumento) {
      this.modelo.tipoDocumentoId = tipoDocumento ? tipoDocumento.id : null
    },
    objpais (pais) {
      this.modelo.paisId = pais ? pais.id : null
    }
  },
  async created () {
    this.$store.subscribe(async (mutation, state) => {
      if (mutation.type === CHANGE_LANGUAGE) {
        this.conseguirTipoDocumento()
        await this.conseguirPaises()
      }
    })
    await this.conseguirObras()
    await this.conseguirTipoDocumento()
    await this.conseguirPaises()
    this.validarQueryParams()
    this.generalParametersUrlLogo = this.generalParameters.urlLgo
  },
  destroyed () {
    this.$_generalParametersMixin_update(this.configColor.primary, this.configColor.secondary, this.generalParametersUrlLogo)
  },
  methods: {
    /**
   * Metodo para abrir link de habeas data
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    abrirLink () {
      window.open(this.objObra ? this.objObra.urlPoliticaTratamientoDatos : '#')
    },
    /**
   * Metodo para guardar datos de donacion .
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    async donar () {
      if (this.modelo.honeypot === '' && await this.$_recaptchaV3Mixin_validate()) {
        this.modelo.obraId = this.objObra.id
        this.modelo.tipoDocumentoId = this.objtipoDocumentoIds.id
        this.modelo.paisId = this.objpais.id
        this.axios.post(GUARDAR_DONACION, this.modelo).then((response) => {
          window.location = response.data
        }).catch(error => {
          this.$_handleErrorMixin_generateError(error)
        })
      }
    },
    async validarFormulario () {
      return await this.$refs.obs.validate() && this.modelo.honeypot === '' && this.$_recaptchaV3Mixin_validate()
    },
    /**
   * Metodo para modificar el valor del modelo de terminos y condiciones.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
    */
    modificarTerminosCondiciones (valor) {
      this.mostrarModal = false
      this.modelo.aceptaTerminosCondiciones = valor
    },
    /**
   * Metodo para mostrar modal de terminos y condiciones.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    abrirLinkTerminosCondiciones () {
      window.open(this.objObra ? this.objObra.urlTerminosCondiciones : '#')
    },
    /**
   * Metodo para traer las obras.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    async conseguirObras () {
      await this.axios.get(TRAER_OBRAS).then((response) => {
        this.obraIds = response.data
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.statusCode === NOT_FOUND) {
          this.obraIds = []
          return
        }
        this.$_handleErrorMixin_generateError(error)
      })
    },
    /**
   * Metodo para traer las campañas por obra.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    async conseguirCampanhas () {
      this.$_generalParametersMixin_update(this.objObra.colorPrincipal, this.objObra.colorSecundario, this.objObra.urlLogo)
      await this.axios.get(`${TRAER_OBRAS}${this.objObra.id}/campanas`).then((response) => {
        this.campanaDonacionIds = response.data
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.statusCode === NOT_FOUND) {
          this.campanaDonacionIds = []
          return
        }
        this.$_handleErrorMixin_generateError(error)
      })
    },
    /**
   * Metodo para traer los Tipos de documentos.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    async conseguirTipoDocumento () {
      await this.axios.get(`${TRAER_TIPOS_DOCUMENTOS}${this.changeLanguage ? this.changeLanguage.toUpperCase() : 'ES'}`, { params: { donacion: true } }).then((response) => {
        this.tipoDocumentoIds = response.data
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.statusCode === NOT_FOUND) {
          this.tipoDocumentoIds = []
          return
        }
        this.$_handleErrorMixin_generateError(error)
      })
    },
    /**
   * Metodo para traer los paises.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    async conseguirPaises () {
      await this.axios.get(`${TRAER_PAISES}${this.changeLanguage ? this.changeLanguage.toUpperCase() : 'ES'}`).then((response) => {
        this.paisIds = response.data
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.statusCode === NOT_FOUND) {
          this.paisIds = []
          return
        }
        this.$_handleErrorMixin_generateError(error)
      })
    },
    limpiarCampos () {
      if (this.objtipoDocumentoIds.descripcion === 'NIT') {
        this.modelo.nombre = null
        this.modelo.apellido = null
      } else {
        this.modelo.razonSocial = null
      }
    },
    async cambiarIdioma (idioma) {
      this.$store.commit(CHANGE_LANGUAGE, idioma)
      this.locale = this.$store.state.changeLanguage
      this.$root.$i18n.locale = this.$store.state.changeLanguage
      for (const error of Object.entries(this.$refs.obs.errors)) {
        if (error[1].length > 0) {
          await this.$refs.obs
          await this.$refs.obs.validate()
          break
        }
      }
    },
    async validarQueryParams () {
      if (this.$route.query.obra) {
        this.objObra = this.obraIds.find(obra => obra.identificadorVid === this.$route.query.obra)
        if (this.objObra) {
          this.disabled.obra = true
          await this.conseguirCampanhas()
          if (this.$route.query.campana) {
            this.modelo.campanaDonacionId = this.campanaDonacionIds.find(campana => campana.identificadorVid.toString() === this.$route.query.campana) ? this.campanaDonacionIds.find(campana => campana.identificadorVid.toString() === this.$route.query.campana).id : null
            if (this.modelo.campanaDonacionId) {
              this.disabled.campana = true
            }
          }
        }
      }
      if (this.$route.query.tipoDocumento) {
        this.objtipoDocumentoIds = this.tipoDocumentoIds.find(tipoDocumento => tipoDocumento.codigo === this.$route.query.tipoDocumento)
      }
      if (this.$route.query.pais) {
        this.objpais = this.paisIds.find(pais => pais.codigoAlfaDos === this.$route.query.pais)
        if (this.objpais) {
          this.disabled.pais = true
        }
      }
      this.validaQueryParam.forEach(data => this.$_validateQueryParamsMixin_indivual(data.data, data.query, data.valida))
    }
  }
}
</script>

<style lang="scss" scoped>
  .idioma-activo {
    -webkit-box-shadow: 0 0 5px 2px var(--v-primary-base);
    box-shadow: 0 0 5px 2px var(--v-primary-base);
  }
</style>
<i18n src="./data/donaciones.json" type="text/json" />
